import type { ReactNode } from 'react';
import { classNames } from '@library/utils';

export interface TableBodyProps {
  children: ReactNode;
  className?: string;
}

export const TableBody = ({
  children,
  className = 'min-w-[1020px]'
}: TableBodyProps) => {
  return (
    <div className={classNames('flex flex-col', className)}>{children}</div>
  );
};
